module.exports = __webpack_public_path__ + "img/WMS_title.291e0ded.svg";